import { Link } from "react-router-dom";
import { HiOutlineInformationCircle } from "react-icons/hi";

import { integrationPath } from "../../routes";
import { PilotsIcon } from "./icons";

/**
 * Empty-state card shown in place of the Pilot slider (`TeamGoalsModal`) or the Pilots
 * breakdown card (`GoalBreakdownModal`) when `pilots_mapped=false` on the NRR endpoint.
 *
 * Prior to PAN-524 the pilot bucket silently auto-hid, leaving CS Leads with two sliders
 * and no way to know pilot goals were an option. This surfaces the missing mapping and
 * links to Settings → Integrations → HubSpot where the pilot end date property is wired.
 *
 * variant="modal" — the pilot-slider slot (larger card with an action button).
 * variant="breakdown" — the pilot-breakdown-card slot (matches the other breakdown rows).
 */
export const PilotsNotMappedCard = ({ variant = "modal" }) => {
  return (
    <div
      className="rounded-xl border border-indigo-200 bg-indigo-50/60 px-6 py-5"
      data-testid="pilots-not-mapped-card"
    >
      <div className="mb-3 flex items-center gap-2">
        <span className="text-indigo-700">
          <PilotsIcon />
        </span>
        <span className="text-sm font-bold text-indigo-900">
          Pilot Conversion Target
        </span>
        <span className="ml-2 rounded-md bg-indigo-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-indigo-600">
          Not configured
        </span>
      </div>
      <div className="flex items-start gap-3">
        <span className="mt-0.5 text-indigo-500">
          <HiOutlineInformationCircle size={20} />
        </span>
        <div className="flex-1">
          <p className="text-[13px] leading-snug text-slate-700">
            Pilot goals aren&rsquo;t available yet — your team hasn&rsquo;t
            mapped the pilot end date property from HubSpot. Once mapped, pilots
            appear as a third goal bucket alongside renewals and expansion.
          </p>
          {variant === "modal" && (
            <Link
              to={integrationPath("hubspot")}
              className="mt-3 inline-flex items-center rounded-[10px] border border-indigo-200 bg-white px-4 py-2 text-[13px] font-semibold text-indigo-600 no-underline transition-colors hover:bg-indigo-100"
            >
              Configure in HubSpot integration →
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
